export default {
    token: state => state.token,
    notifications: state => state.notifications,
    bookingNotifications: state => state.bookingNotifications,
    formOfPayments: state => state.formOfPayments,
    credentials: state => state.credentials,
    emptyCredentials: state => state.emptyCredentials,
    agencies: state => state.agencies,
    companies: state => state.companies,
    connectionRequests: state => state.connectionRequests,
    transactions: state => state.transactions,
    tickets: state => state.tickets,
    ticketsCountByStep: state => state.ticketsCountByStep,
    analytics: state => state.analytics,
    settings: state => state.settings,
    angecyInfo: state => state.angecyInfo,
    login: state => state.login,
    onboarding: state => state.onboarding,
    accountInfo: state => state.accountInfo,
    isAdmin: state => (state.accountInfo.user_type == 'Admin' || state.accountInfo.user_type == 'Support'),
    searchResult: state => state.searchResult,
    searchState: state => state.searchState,
    bookingLoader: state => state.bookingLoader,
    priceCalculationError: state => state.priceCalculationError,
    bookings: state => state.bookings,
    defaultBookings: state => state.defaultBookings,
    openedBooking: state => state.openedBooking,
    selectedBookingList: state => state.selectedBookingList,
    searchReissue: state => state.searchReissue,
    reissueOffers: state => {
      if (state.reissueOffers.origin_destinations) {
          return Object.assign(state.reissueOffers, {origin_destinations: state.reissueOffers.origin_destinations.map((obj, i) => Object.assign(obj, {id: i}))})
      }
      return state.reissueOffers
    },
    reissueSearchParams: state => state.reissueSearchParams,
    hiddenBooking: state => state.hiddenBooking,
    // The scope records which carriers the offers on screen were fetched with:
    //   []    – no carrier restriction: every channel was queried
    //   [..]  – only these carriers were queried, because they all lived in one
    //           channel and the server said so
    //   null  – a search reported nothing at all, so this is unknown
    //
    // Narrowing within a known scope is pure frontend filtering. Reaching past
    // it needs a new server search, and so does an unknown scope — but only
    // when the carriers actually move, so a command that leaves them alone
    // never pays for the uncertainty.
    carrierSearchNeeded: state => (carriers = [], previous = null) => {
      const scope = state.serverCarrierScope;
      const wanted = normalizeCarriers(carriers);
      const before = normalizeCarriers(previous ?? state.searchFilters?.carriers);

      if (scope === null || scope === undefined) return !sameCarriers(wanted, before);
      if (scope.length === 0) return false;

      return wanted.length === 0 || wanted.some(code => !scope.includes(code));
    },
}

function normalizeCarriers(carriers) {
  return [...new Set((carriers || []).map(code => String(code).toUpperCase()))].sort();
}

function sameCarriers(one, other) {
  return one.length === other.length && one.every((code, index) => code === other[index]);
}
